import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgClose} from "~/assets/svg/close.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmCloseIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgClose id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
